import { receiptList } from "constants/receipt";

const initialState = {
  receiptList: null,
};

const receipt = (state = initialState, action) => {
  switch (action.type) {
    case receiptList:
      return { ...state, receiptList: action.payload };
    default:
      return state;
  }
};

export default receipt;
